import { Activity, Users, Wallet, FileText } from "lucide-react";

export const sidebarLinks = [
  {
    id: 1,
    title: "Dashboard",
    link: "/",
    icon: <Activity size={20} />,
    permissions: [
      "see_dp_progress_reports_1",
      "see_dp_progress_report_2",
      "see_stats",
    ],
  },
  {
    id: 2,
    title: "Members",
    link: "/members",
    icon: <Users size={20} />,
    permissions: ["see_members", "manage_members"],
  },
  {
    id: 3,
    title: "Deposits",
    link: "/deposits",
    icon: <Wallet size={20} />,
    permissions: ["see_deposits", "manage_deposits"],
  },
  {
    id: 4,
    title: "Istavrity(s)",
    link: "/istavrity",
    icon: <FileText size={20} />,
    permissions: ["see_istavrity", "manage_istavrity"],
  },
  {
    id: 5,
    title: "Manage Users",
    link: "/manage-user",
    icon: <Users size={20} />,
    permissions: ["manage_users"],
  },
];
